var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b;
import { Component, Vue, Model, Prop, Watch } from "vue-facing-decorator";
import { ReportScheduleModel, PaginatedEnumerableOfReportLogModel, GetReportLogListPaginatedQuery, ReportClient, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import { DatePresetOption } from "@/common/enums/date-preset";
import { HttpHelper } from "@/app/utils/http-helper";
import { DateHelper } from "@/app/utils/date-helper";
import { DownloadUtil } from "@/app/utils/download-util";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
import moment from 'moment';
const reportClient = new ReportClient(window.apiUrl);
let ReportManagerVue = class ReportManagerVue extends Vue {
    constructor() {
        super(...arguments);
        this.showModal = false;
        // singleton
        this.working = false;
        this.loaded = false;
        this.data = new PaginatedEnumerableOfReportLogModel();
        this.datePickerConfig = DateHelper.GetDefaultDatePickerConfig();
        this.dateFilterOptions = ["1 Day", "3 Days", "5 Days", "Week", "All", "..."];
        this.dateFilterOption = "";
        this.sorter = new Sorter(new SortDescription({
            fieldName: "whenCreated",
            direction: SortDirection.Descending
        }));
        this.query = new GetReportLogListPaginatedQuery({
            pageNo: 1,
            pageSize: 50,
            keywords: "",
            reportScheduleId: null,
            reportId: null,
            sort: this.sorter.currentSort,
            start: new Date(),
            end: new Date()
        });
        this.startDate = new Date();
        this.endDate = new Date();
    }
    created() {
        this.resetDateFilterOption();
    }
    getReportLogs() {
        var _a, _b;
        if (this.working || this.areDatesInvalid)
            return;
        if (!this.showModal || (!((_a = this.selectedModel) === null || _a === void 0 ? void 0 : _a.id) && !this.companyId))
            return;
        this.working = true;
        this.query.reportScheduleId = (_b = this.selectedModel) === null || _b === void 0 ? void 0 : _b.id;
        this.query.companyId = this.companyId;
        this.query.sort = this.sorter.currentSort;
        this.query.start = this.startDate ? DateHelper.convertToDate(this.startDate.toString()) : null;
        this.query.end = this.endDate ? DateHelper.convertToDate(this.endDate.toString()) : null;
        reportClient.getReportScheduledLogs(this.query).then((response) => {
            this.data = response;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.loaded = true;
        });
    }
    onSortChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.getReportLogs();
            }
            catch (e) {
                console.error(e);
            }
        });
    }
    ;
    download(item) {
        this.working = true;
        reportClient
            .getReportLogFile(item.id)
            .then(response => {
            if (!response) {
                Notifier.onWarning("Could not download chart data.");
                return;
            }
            DownloadUtil.handleFileDownload(response);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    //Computed
    get noData() {
        var _a;
        return this.loaded && (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.records) || !this.data.records.length);
    }
    ;
    getDateTime(date) {
        return DateHelper.convertToFriendlyMomentTimeString(date);
    }
    ;
    get showDatePickers() {
        return this.dateFilterOption == "...";
    }
    ;
    resetDateFilterOption() {
        this.setDateFilterOption("Week");
    }
    ;
    setDateFilterOption(option) {
        this.dateFilterOption = option;
        if (this.dateFilterOption == "...")
            return;
        this.setDateRange();
        this.getReportLogs();
    }
    ;
    setDateRange() {
        let range = DateHelper.getDateRange(DatePresetOption.OneMonth);
        let now = new Date();
        let end = moment(now.toISOString()).endOf("day").toDate();
        switch (this.dateFilterOption) {
            case "1 Day":
                range = { start: moment(now.toISOString()).add(-1, "days").startOf("day").toDate(), end: end };
                break;
            case "3 Days":
                range = { start: moment(now.toISOString()).add(-3, "days").startOf("day").toDate(), end: end };
                break;
            case "5 Days":
                range = { start: moment(now.toISOString()).add(-5, "days").startOf("day").toDate(), end: end };
                break;
            case "Week":
                range = DateHelper.getDateRange(DatePresetOption.SevenDays);
                break;
            case "All":
                range = { start: null, end: null };
                break;
        }
        if (!range)
            return;
        this.startDate = range.start;
        this.endDate = range.end;
    }
    ;
    get areDatesInvalid() {
        if (this.startDate == null || this.endDate == null || this.startDateInvalid || this.endDateInvalid)
            return false;
        let startTime = DateHelper.convertToDate(this.startDate.toString());
        let endTime = DateHelper.convertToDate(this.endDate.toString());
        return (startTime >= endTime);
    }
    ;
    get startDateInvalid() {
        if (!this.startDate)
            return true;
        try {
            return isNaN(Date.parse(this.startDate.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    get endDateInvalid() {
        if (!this.endDate)
            return true;
        try {
            return isNaN(Date.parse(this.endDate.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
};
__decorate([
    Model(),
    __metadata("design:type", Boolean)
], ReportManagerVue.prototype, "showModal", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof ReportScheduleModel !== "undefined" && ReportScheduleModel) === "function" ? _a : Object)
], ReportManagerVue.prototype, "selectedModel", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Number)
], ReportManagerVue.prototype, "companyId", void 0);
__decorate([
    Watch("showModal"),
    Watch("selectedModel"),
    Watch("companyId"),
    Watch("sorter.currentSort"),
    Watch("query.pageNo"),
    Watch("startDate"),
    Watch("endDate"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
], ReportManagerVue.prototype, "onSortChanged", null);
ReportManagerVue = __decorate([
    Component({
        name: "ReportScheduleedLogVue",
        expose: ["show"],
        components: {}
    })
], ReportManagerVue);
export default ReportManagerVue;
